__webpack_require__.p = "https://cdn.gamifiera.com/static/gmf/";